import {styled} from '@mui/material';

const Container = styled('div')`
	background-color: ${({theme}) => theme.palette.primary.main};
	margin-top: 26px;
`;

export {Container};
